import { useCallback } from 'react';
import { useAlertStore } from './AlertStore';
import MultiMessageAlert, { AlertMessage } from './MultiMessageAlert';

export type NotifyAlertOptions = {
  messages: AlertMessage[];
  onCloseCallback?: () => void;
  okMessageKey?: string;
};

export const useNotifyMultiMessageAlert = () => {
  const { showAlert, hideAlert } = useAlertStore();

  const notifyAlert = useCallback(
    ({ messages, onCloseCallback, okMessageKey }: NotifyAlertOptions) => {
      showAlert({
        content: (
          <MultiMessageAlert
            messages={messages}
            {...(okMessageKey ? { okMessageKey } : {})}
            onClose={() => {
              hideAlert();
              if (onCloseCallback) onCloseCallback();
            }}
          />
        ),
      });
    },
    [showAlert, hideAlert]
  );

  return notifyAlert;
};
